/** The overview screen and its first-run state. */
const en = {
  title: 'Overview',
  subtitle: 'last 30 days',
  kpi: {
    openTickets: 'Open tickets',
    highFrustration: 'High-frustration',
    openErrors: 'Open errors',
    sessions30d: 'Sessions (30d)',
    avgFrustration: 'Avg frustration',
    alerts24h: 'Alerts (24h)',
  },
  panels: {
    frustrated: 'Most frustrated sessions',
    recentAlerts: 'Recent alerts',
    topErrors: 'Top errors',
    ticketsByStatus: 'Tickets by status',
    viewAll: 'View all',
    openTickets: 'Open Tickets',
  },
  empty: {
    frustrated: 'No frustrated sessions.',
    alerts: 'No alerts have fired.',
    errors: 'No errors captured.',
    tickets: 'No tickets yet.',
  },
  chips: {
    rage: 'rage',
    err: 'err',
  },
  firstRun: {
    welcome: 'Welcome to ReplayOps',
    body: "Create your first project to get a tracking snippet and start recording sessions. You'll see frustration signals, errors and replays here as soon as data comes in.",
    cta: 'Create your first project',
    dialogTitle: 'New project',
    nameLabel: 'Project name',
    namePlaceholder: 'e.g. Marketing site',
  },
  ago: {
    justNow: 'just now',
    minutes: (n: number) => `${n}m ago`,
    hours: (n: number) => `${n}h ago`,
    days: (n: number) => `${n}d ago`,
  },
};

const tr: typeof en = {
  title: 'Genel bakış',
  subtitle: 'son 30 gün',
  kpi: {
    openTickets: 'Açık talepler',
    highFrustration: 'Yüksek zorlanma',
    openErrors: 'Açık hatalar',
    sessions30d: 'Oturumlar (30g)',
    avgFrustration: 'Ort. zorlanma',
    alerts24h: 'Uyarılar (24s)',
  },
  panels: {
    frustrated: 'En çok zorlanılan oturumlar',
    recentAlerts: 'Son uyarılar',
    topErrors: 'En sık hatalar',
    ticketsByStatus: 'Duruma göre talepler',
    viewAll: 'Tümünü gör',
    openTickets: 'Talepleri aç',
  },
  empty: {
    frustrated: 'Zorlanma yaşanan oturum yok.',
    alerts: 'Henüz uyarı tetiklenmedi.',
    errors: 'Yakalanan hata yok.',
    tickets: 'Henüz talep yok.',
  },
  chips: {
    rage: 'öfke',
    err: 'hata',
  },
  firstRun: {
    welcome: "ReplayOps'a hoş geldiniz",
    body: 'İlk projenizi oluşturun; izleme snippet’ini alın ve oturum kaydetmeye başlayın. Veri gelmeye başladığı anda zorlanma sinyallerini, hataları ve kayıtları burada göreceksiniz.',
    cta: 'İlk projenizi oluşturun',
    dialogTitle: 'Yeni proje',
    nameLabel: 'Proje adı',
    namePlaceholder: 'örn. Pazarlama sitesi',
  },
  ago: {
    justNow: 'az önce',
    minutes: (n: number) => `${n} dk önce`,
    hours: (n: number) => `${n} sa önce`,
    days: (n: number) => `${n} gün önce`,
  },
};

export const dashboard = { en, tr };
